module.exports = __webpack_public_path__ + "img/toujours-jaune-tshirt-particles.af29f519.jpg";